import {
  Card,
  Title,
  Box,
  CardProps,
  ActionIcon,
  useMantineTheme,
  Group,
  Sx,
} from "@mantine/core";
import { FC, ReactNode, memo } from "react";
import { IoIosAddCircle } from "react-icons/io";
import { CardRadius, HeightCard } from "src/utils/constants";

export interface ActionCardProps extends CardProps {
  title: string;
  titleContent?: ReactNode;

  startIconButton?: ReactNode;
  leftIconButton?: ReactNode;
  rightIconButton?: ReactNode;
  hideModal?: boolean;
  handleModal?: () => void;
  disabled?: boolean;

  bannerContent?: string;
  bannerColor?: string;
  bannerBgColor?: string;

  margin?: number | string;
  hideChild?: boolean;
  height?: HeightCard;
  childXs?: Sx;
  size?: "sm" | "md" | "lg";
  radius?: CardRadius;
  overflow?: "visible" | "hidden";
  groupXs?: Sx;
  headerOnly?: boolean;
}

const ActionCard: FC<ActionCardProps> = ({
  title,
  titleContent,

  leftIconButton,
  rightIconButton,
  startIconButton,
  disabled = false,

  bannerContent = "",
  bannerBgColor = "#4d4d4d",
  bannerColor = "#fff",
  height = HeightCard.lg,
  groupXs = {},
  radius = CardRadius.md,

  hideModal = false,
  handleModal,
  margin,
  hideChild = false,
  childXs = {},
  children,
  size = "lg",
  overflow = "visible",
  headerOnly,
  ...restProps
}) => {
  const theme = useMantineTheme();

  let border = headerOnly ? "none" : `1px solid ${theme.colors.primary[6]}`;
  let bg = theme.colors.primary[6];
  let color = theme.colors.primaryTextColor[6];

  const isChildPresent = children && !hideChild;
  let isBig = height === HeightCard.lg;

  return (
    <Card
      style={{
        border,
        color,
        overflow: overflow,
      }}
      radius={radius}
      w="100%"
      m={0}
      p={0}
      bg={theme.colors.secondary[6]}
      {...restProps}
    >
      <Group
        position="apart"
        w={"100%"}
        bg={bg}
        p="0 15px"
        sx={{
          borderBottom: !hideChild && !headerOnly ? border : "none",
          borderRadius:
            !hideChild && !headerOnly ? `${radius}px ${radius}px 0 0` : radius,
          color,
          height,
          ...groupXs,
        }}
      >
        {startIconButton && <>{startIconButton}</>}

        {titleContent || <Title order={isBig ? 4 : 5}>{title}</Title>}

        <Group>
          {leftIconButton && <>{leftIconButton}</>}

          {handleModal && !hideModal && (
            <ActionIcon
              onClick={handleModal}
              bg="transparent"
              disabled={disabled}
              sx={{
                "&:hover": {
                  backgroundColor: disabled
                    ? undefined
                    : theme.colors.primary[2],
                },
              }}
            >
              <IoIosAddCircle
                color={disabled ? theme.colors.light[6] : color}
                size={isBig ? 30 : 24}
              />
            </ActionIcon>
          )}
          {rightIconButton && <>{rightIconButton}</>}
        </Group>
      </Group>
      {/* </Grid> */}
      {bannerContent && (
        <Title
          order={6}
          bg={bannerBgColor}
          color={bannerColor}
          p="4px 0"
          ta="center"
        >
          {bannerContent}
        </Title>
      )}
      {isChildPresent && (
        <Box
          sx={childXs}
          p={
            typeof margin === "number"
              ? margin
              : hideChild
              ? 0
              : size === "lg"
              ? 15
              : 10
          }
        >
          {children}
        </Box>
      )}
    </Card>
  );
};

export default memo(ActionCard);
